export default {
  data() {
    return {};
  },
  methods: {
    agregarColumnasPagos() {
      const existeColumnaPagoMatricula = this.columnDefs.some((columna) => columna.headerName === 'PAGO MÁTRICULA');
      const existeColumnaPagoColegiatura = this.columnDefs.some((columna) => columna.headerName === 'PAGO COLEGIATURA');
      const existeColumnaPagoCertificacion = this.columnDefs.some(
        (columna) => columna.headerName === 'PAGO CERTIFICACIÓN',
      );

      if (existeColumnaPagoMatricula || existeColumnaPagoColegiatura || existeColumnaPagoCertificacion) {
        return;
      }

      const indiceColumnaEstadosAcademicos = this.columnDefs.findIndex(
        (columna) => columna.headerName === 'ESTADO ACADÉMICO',
      );

      if (indiceColumnaEstadosAcademicos !== -1) {
        this.columnDefs.splice(indiceColumnaEstadosAcademicos + 1, 0, ...this.columnasPagos);
      }
    },
    quitarColumnasPagos() {
      const camposColumnasPagos = this.columnasPagos.map((columna) => columna.headerName);

      this.columnDefs = this.columnDefs.filter((columna) => !camposColumnasPagos.includes(columna.headerName));
    },
  },
};
